import isEmpty from 'lodash/isEmpty'

import type { Permission, PermissionCatalog } from '@ztechapps/common.contract'

const matchesSearch = (value: string, search: string): boolean => value.toLowerCase().includes(search)

const permissionMatches = (permission: Permission, search: string): boolean =>
  matchesSearch(permission.label, search) || matchesSearch(permission.value, search) || matchesSearch(permission.description, search)

/**
 * Filters a permission catalog by a search value, walking the module/permission tree.
 * A module whose own label matches keeps every one of its permissions; otherwise only the
 * permissions whose label, value, or description match survive, and modules left empty are dropped.
 */
export function filterPermissionCatalog({ catalog, searchValue }: { catalog: PermissionCatalog; searchValue: string }): PermissionCatalog {
  const trimmedSearch = searchValue.trim()

  if (isEmpty(trimmedSearch)) return catalog

  const search = trimmedSearch.toLowerCase()

  return catalog.reduce<PermissionCatalog>((result, module) => {
    const permissions = matchesSearch(module.label, search) ? module.permissions : module.permissions.filter((permission) => permissionMatches(permission, search))

    if (!isEmpty(permissions)) {
      result.push({ ...module, permissions })
    }

    return result
  }, [])
}
